import { createFileRoute, redirect } from '@tanstack/react-router'
import { VirtualReportDetailPage } from 'pages/virtualReports/VirtualReportDetailPage'
import { VirtualReportsLayout } from 'pages/virtualReports/VirtualReportsLayout'
import { virtualReportDetailsSearchParams } from 'routes/virtual-reports/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, componentId } = Route.useSearch()

  return (
    <VirtualReportsLayout>
      <VirtualReportDetailPage
        orgId={orgId}
        siteId={siteId}
        componentId={componentId}
      />
    </VirtualReportsLayout>
  )
}

export const Route = createFileRoute('/virtual-reports/details')({
  component: RouteComponent,
  validateSearch: virtualReportDetailsSearchParams,
  beforeLoad: ({ search }) => {
    if (!search.componentId) {
      throw redirect({
        to: '/virtual-reports',
        search: { siteId: search.siteId },
      })
    }
  },
  staticData: {
    title: 'Virtual Report',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      hideMenuButton: true,
      enableScrolling: false,
    },
  },
})
